import { render, staticRenderFns } from "./FormSendAnnouncement.vue?vue&type=template&id=55bebf8e&"
import script from "./FormSendAnnouncement.vue?vue&type=script&lang=js&"
export * from "./FormSendAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports